export default `vec3 Q;
    float i,d=1.,a;
    Q=abs(mod(p,1.8)-.9);
    a=3.;
    for(int j=0;j++<8;)
      Q=2.*clamp(Q,-.9,.9)-Q,
      d=dot(Q,Q),
      Q/=d,
      a/=d,
      Q+=.05;
    return d=(Q.x+Q.y+Q.z-1.6)/a;
  }`